module.exports = __webpack_public_path__ + "medical-and-health.133db215967080690067.svg";


//////////////////
// WEBPACK FOOTER
// C:/Users/INMOGR/Desktop/Angular Project/src/assets/fonts/line-icons-pro/medical/webfont/medical-and-health.svg
// module id = ../../../../../src/assets/fonts/line-icons-pro/medical/webfont/medical-and-health.svg
// module chunks = styles